import Validator from './Validator'

class FRvalidator extends Validator {}

export default FRvalidator
